export const BUTTON_ATTACK = 1;
